export const XAdminRole = {
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN"
};
